import {I18nProvider as Provider} from '@lingui/react';
import {useCatalogs} from './hooks/useCatalogs';
import {useLocale} from './hooks/useLocale';
import {i18n2, setupLocale} from './i18n';
import React, {useEffect} from 'react';

const I18nProvider = (props) => {
  const catalogs = useCatalogs();
  const locale = useLocale();

  useEffect(() => {
    setupLocale(locale, catalogs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Provider i18n={i18n2}>{props.children}</Provider>;
};

export default I18nProvider;
